import * as React from "react";
import { listVerantwortlichkeiten, type Verantwortlichkeit } from "../../services/verantwortlichkeitService";

// Modul-Cache: der Katalog wird systemweit nur einmal geladen.
let cache: Verantwortlichkeit[] | null = null;
let inflight: Promise<Verantwortlichkeit[]> | null = null;

/** Lädt den globalen Verantwortlichkeiten-Katalog (gecacht). */
export function useVerantwortlichkeiten(): { items: Verantwortlichkeit[]; loading: boolean } {
  const [items, setItems] = React.useState<Verantwortlichkeit[]>(cache ?? []);
  const [loading, setLoading] = React.useState<boolean>(cache == null);

  React.useEffect(() => {
    if (cache) return;
    if (!inflight) {
      inflight = listVerantwortlichkeiten()
        .then((d) => {
          cache = d;
          return d;
        })
        .finally(() => {
          inflight = null;
        });
    }
    let alive = true;
    inflight
      .then((d) => {
        if (alive) {
          setItems(d);
          setLoading(false);
        }
      })
      .catch(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return { items, loading };
}

/** Cache leeren (z. B. nachdem der Katalog in den Einstellungen geändert wurde). */
export function invalidateVerantwortlichkeitenCache(): void {
  cache = null;
}
